import type { OfficeHost } from "@/core/types";
import { Icon } from "./Icon";

interface HostNoticeProps {
  expectedHost: OfficeHost;
  actualHost: OfficeHost | null;
}

/**
 * Hinweis, falls der Kurs außerhalb der passenden Office-Anwendung geöffnet
 * wird. Die Inhalte bleiben lesbar, nur die Prüfungen funktionieren nicht.
 */
export function HostNotice({ expectedHost, actualHost }: HostNoticeProps) {
  if (actualHost === expectedHost) return null;

  return (
    <div className="notice" role="note">
      <Icon name="info" />
      <p>
        <strong>Kein {expectedHost}-Dokument verbunden.</strong>{" "}
        {actualHost
          ? `Dieser Kurs gehört zu ${expectedHost}, das Add-in läuft aber gerade in ${actualHost}.`
          : `Geprüft wird nur im Seitenpanel von ${expectedHost}.`}
      </p>
    </div>
  );
}
